import { connect } from 'react-redux';
import { Field } from 'redux-form';

import { TextField, SelectField } from 'common/components/forms';
import BirthDateFormFields from 'common/components/forms/BirthDateFormFields';
import { listAllCountriesOptionArray } from 'common/helpers/addresses';
import { getDefaultCountryCode } from 'common/helpers/miscHelper';
import { phoneNormalize } from 'common/helpers/phoneHelper';

const AddressForm = (props) => {
  const { settings } = props;
  return (
    <>
      <BirthDateFormFields
        name="birthDate"
        countryCode={getDefaultCountryCode(settings)}
      />
      <div className="c7-form__group">
        <Field
          name="firstName"
          component={TextField}
          label="First Name"
          autocomplete="given-name"
          required
        />
        <Field
          name="lastName"
          component={TextField}
          label="Last Name"
          autocomplete="family-name"
          required
        />
      </div>
      <Field
        name="countryCode"
        component={SelectField}
        optionArray={countryArray}
        label="Country"
        required
      />
      <Field
        name="phone"
        component={TextField}
        label="Phone"
        formType="tel"
        normalize={phoneNormalize}
        autocomplete="tel-national"
        required
      />
    </>
  );
};

const countryArray = listAllCountriesOptionArray(false);

const mapStateToProps = (state) => ({
  settings: state.setting
});

export default connect(mapStateToProps)(AddressForm);
